import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  LinearProgress,
  colors,
} from "@mui/material";
import logo from "../../assets/images/merchantnewlogo.svg";
import banner from "../../assets/images/3d-render-tax-payment-financial-business-concept.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import baseUrl from "../../config/baseUrl";
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    password: "",
    confirm_password: "",
  });
  useEffect(() => {
    AOS.init({ duration: 1500, offset: 100, easing: "ease-in-out", once: true });
  }, []);
  const handleChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
  };
  const handleNextStep = async () => {
    if (formData.email.trim() === "") {
      alert("Please enter your email.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${baseUrl}/emailSendOtp`, {
        email: formData.email,
      });
      console.log(res)
      alert(res.data.message);
      setStep(2);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    const { email, otp, password, confirm_password } = formData;
    if (!otp || !password || !confirm_password) {
      alert("Please fill all fields.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${baseUrl}/forgotPassword`, {
        email,
        otp,
        newpassword: password,
        confirmPassword: confirm_password,
      });
      alert(res.data.message);
      navigate("/DepositPortal");
    } catch (err) {
      alert(err.response?.data?.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box display="flex" flexDirection={{ xs: "column", md: "row" }} height="100vh">
      {/* Left Banner */}
      <Box
        data-aos="fade-right"
        sx={{
          width: { xs: "100%", md: "70%" },
          height: "100vh",
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      />
      {/* Right Form */}
      <Box
        data-aos="fade-left"
        sx={{
          width: { xs: "100%", md: "30%" },
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          bgcolor: colors.common.white,
          padding: { xs: 3, md: 5 },
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ textAlign: "center", mb: 2 }} data-aos="zoom-in">
          <img src={logo} alt="logo" height={70} />
          <Typography sx={{ mt: 2, fontWeight: "bold" }}>
            {step === 1 ? "Forgot Password" : "Reset Your Password"}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={step === 1 ? 50 : 100}
            sx={{
              mt: 2,
              height: 10,
              borderRadius: "50px",
              backgroundColor: "#F5F5F5",
              "& .MuiLinearProgress-bar": {
                backgroundImage: "linear-gradient(90deg, #43CEA2, #185A9D)",
              },
            }}
          />
        </Box>
        {/* Step Form + Button */}
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
          {step === 1 ? (
            <StepOne handleChange={handleChange} formData={formData} navigate={navigate} />
          ) : (
            <StepTwo handleChange={handleChange} formData={formData} />
          )}
          <Button
            onClick={step === 1 ? handleNextStep : handleSubmit}
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{
              mt: 2,
              padding: "12px",
              fontSize: "1rem",
              borderRadius: "8px",
              backgroundColor: "#185A9D",
              "&:hover": { backgroundColor: "#1D4C7C" },
            }}
          >
            {loading
              ? "Please wait..."
              : step === 1
              ? "Send OTP"
              : "Reset Password"}
          </Button>
          <Typography
            variant="body2"
            sx={{
                mt: 2,
                cursor: "pointer",
                textAlign: 'end'
            }}
        >
            If You Want To Login?{" "}
            <Button
                onClick={() => {navigate("/DepositPortal")}}
                color="primary"
                sx={{ fontSize: "1rem", fontWeight: "bold" }}
            >
                Login
            </Button>
        </Typography>
        </Box>
      </Box>
    </Box>
  );
};
// Step 1
const StepOne = ({ handleChange, formData, navigate }) => (
  <>
    <Box sx={{ pr: 1 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "#185A9D" }}>
        Enter Your Email
        </Typography>
        <TextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={(e) => handleChange(e, "email")}
        fullWidth
        margin="normal"
        />
    </Box>
  </>
);
// Step 2
const StepTwo = ({ handleChange, formData }) => (
  <Box sx={{ pr: 1 }}>
    <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "#185A9D" }}>
      Set New Password
    </Typography>
    <TextField
      label="Email"
      name="email"
      type="email"
      value={formData.email}
      fullWidth
      margin="normal"
      disabled
    />
    <TextField
      label="OTP"
      name="otp"
      type="text"
      value={formData.otp}
      onChange={(e) => handleChange(e, "otp")}
      fullWidth
      margin="normal"
    />
    <TextField
      label="New Password"
      name="password"
      type="password"
      value={formData.password}
      onChange={(e) => handleChange(e, "password")}
      fullWidth
      margin="normal"
    />
    <TextField
      label="Confirm New Password"
      name="confirm_password"
      type="password"
      value={formData.confirm_password}
      onChange={(e) => handleChange(e, "confirm_password")}
      fullWidth
      margin="normal"
    />
    <Typography
      variant="caption"
      sx={{
        mt: 1,
        color: "text.secondary",
        fontSize: "0.75rem",
        lineHeight: 1.4,
        wordBreak: "break-word",
        flexShrink: 0,
      }}
    >
      <strong>Note:</strong> Your password must be 8–20 characters, contain letters,
      numbers, and one of these characters:{" "}
      <strong style={{ color: "red" }}>"$@#^|!~=+-_."</strong>
    </Typography>
  </Box>
);
export default ForgotPassword;